import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { UnitRepositoryBase } from '@skylab-shared/business';
export { UnitRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(UnitRepositoryBase)
export class UnitRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
    ) { }
}
